import { SIT, PREPROD, PROD } from '../constants';

export const getIndexForAddOns = (env: string) => {
  switch (env) {
    case SIT:
      return 'sit_addons_v1';
    case PREPROD:
      return 'preprod_addons_v1';
    case PROD :
      return 'prod_addons_v1';
    default:
      return 'sit_addons_v1';
  }
}